import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import Vue from 'vue';
import { dependencyMethod, 
          trackException, 
          setUserContextMethod, 
          clearUserContextMethod } from "@/plugins/ApplicationInsight/Utils";
import GlobalConfig from "@/GlobalConfig";
import Axios from "axios";

const appInsights = new ApplicationInsights({ config: {
    instrumentationKey: GlobalConfig.APP_INSIGHT_KEY,
    autoTrackPageVisitTime: true,
    disableFetchTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    enableAjaxErrorStatusText: true,
    //correlationHeaderExcludedDomains: ['myapp.azurewebsites.net', '*.queue.core.windows.net'],
    enableAutoRouteTracking: true
  /* ...Other Configuration Options... */
} });
appInsights.loadAppInsights();
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
// -------------------------------------------------- track exceptions
Vue.config.errorHandler = (error) => {
  trackException(appInsights, error);
};

const $appInsightVueObject = {
  setUserContext: (payload: {authenticatedUserId: string, accountId?: string, storeInCookie?:boolean }) =>  setUserContextMethod(appInsights, payload),
  clearUserContext: () => clearUserContextMethod(appInsights),
};

Vue.prototype.$appInsight = $appInsightVueObject;

declare module "vue/types/vue" {
  interface Vue {
    $appInsight: typeof $appInsightVueObject;
  }
}